import React from 'react';
import { SelectArrowDown } from './selectArrow';
import { AiOutlineClose } from "react-icons/ai";

class CustomSelect extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false
    };
  }

  render() {
    const { itemEvent } = this.props;
 
    return (
      <div>
        <div className='customSelect' onClick={() => { this.setState({ modal: this.state.modal == true ? false : true }) }}>
          <div>{this.props.items.find(item => item.id === this.props.selectedItem)?.name}</div>
          <SelectArrowDown />
        </div>
        {
          this.state.modal == true ?
            <div className='customSelectModal'>
              <div className='customSelectModal_bg' onClick={() => { this.setState({ modal: false }) }}></div>
              <div className='customSelectModal_close' onClick={() => { this.setState({ modal: false }) }}><AiOutlineClose /></div>
              <div className='customSelectModal_body'>
                {
                  this.props.items && this.props.items.length == 0 ?
                    ""
                    :
                    this.props.items.map((elem, index) => {
                      return (<div key={index} className="CSelect_item" onClick={() => (this.setState({ modal: false }, itemEvent(elem.id, elem.name, this.props.index)))}>
                        <div className='CSelect_item_name'>{elem.name}</div>
                        <div className={`selectMark ${elem.id == this.props.items.find(item => item.id === this.props.selectedItem)?.id ? 'marking' : ''}`}></div>
                      </div>)
                    })
                }
              </div>
            </div>
            :
            ""
        }
      </div>
    );
  }
}

export default CustomSelect;